import { useMapStore } from '@/store/useMapStore';

const PaletteInfo = () => {
  const { selectedPalette, palettes } = useMapStore();
  const palette = palettes.find(p => p.id === selectedPalette);

  if (!palette) return null;

  const dots = [
    { label: 'Base', color: palette.colors.baseBoardColor },
    { label: 'Map', color: palette.colors.mapColor },
    { label: 'Text', color: palette.colors.textColor },
  ];

  return (
    <div aria-live="polite" style={{ paddingTop: '4px' }}>
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        {dots.map(dot => (
          <div key={dot.label} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div
              style={{
                width: '14px',
                height: '14px',
                borderRadius: '50%',
                backgroundColor: dot.color,
                border: '1px solid rgba(0,0,0,0.12)',
                flexShrink: 0,
              }}
            />
            <span style={{
              fontSize: '0.7rem',
              color: 'var(--brand-muted)',
              fontFamily: 'var(--font-body)',
            }}>
              <span style={{ textTransform: 'uppercase', fontWeight: 500 }}>{dot.label}</span>{' '}
              {dot.color.toUpperCase()}
            </span>
          </div>
        ))}
      </div>
      {palette.description && (
        <p style={{
          fontSize: '0.8rem',
          color: 'var(--brand-muted)',
          fontFamily: 'var(--font-body)',
          marginTop: '8px',
          lineHeight: 1.4,
        }}>
          {palette.description}
        </p>
      )}
    </div>
  );
};

export default PaletteInfo;
